import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupCurrency } from "../../../Shared/NewForms/NFlookupCurrency";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFLookupWarehouse } from "../../../Shared/NewForms/NFLookupWarehouse";
import { NFLookupVendor } from "../../../Shared/NewForms/NFLookupVendor";
import { NFLookupContract } from "../../../Shared/NewForms/NFLookupContract";
import { NFLookupUnit } from "../../../Shared/NewForms/NFLookupUnit";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

export const ReturnOfGoodsFromVendorsDetailMain = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Document #")} disabled fieldName={"documentNumber"} />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("Document Date")} fieldName={"documentDate"} required={true} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupContract title={t("Contract")} fieldName={"contractId"} />
        </Col>
        <Col sm={6}>
          <NFLookupCurrency title={t("Currency")} fieldName={"currencyId"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupUnit title={t("Unit")} fieldName={"unitId"} />
        </Col>
        <Col sm={6}>
          <NFLookupVendor title={t("Vendor")} fieldName={"vendorId"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupWarehouse title={t("Warehouse")} fieldName={"warehouseId"} companyId={watch("companyId")} />
        </Col>
        <Col sm={6}>
          <NFLookupCompany title={t("Company")} fieldName={"companyId"} />
        </Col>
      </Row>
    </>
  );
};
